module.exports = __webpack_public_path__ + "static/assets/26a4aecd5158e8663b90d5edfba5e25a.mp3";